<template>
    <div class="sso-wrap">
        <div class="sso-kotak">
            <template v-if="!pesan">
                <i class="fa fa-spinner fa-spin fa-2x mb-3"></i>
                <h5>Masuk melalui SIMASKET…</h5>
            </template>
            <template v-else>
                <h5>Login SSO tidak berhasil</h5>
                <p class="text-muted">{{ pesan }}</p>
                <router-link to="/" class="btn btn-primary btn-sm">Masuk dengan username &amp; password</router-link>
            </template>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    /**
     * Pintu SSO dari SIMASKET (Home::sso di bandung-simasket).
     * Tiket sekali pakai (60 detik) dibawa di query #/sso?ticket=..., ditukar ke
     * BE /sso/masuk menjadi token login biasa -- penyimpanannya sama persis
     * dengan Signin.vue.
     */
    export default {
        name: 'SsoMasuk',
        data() {
            return { pesan: '' };
        },
        mounted() {
            const tiket = this.$route.query.ticket;

            // Buang tiket dari URL & riwayat browser -- sudah terbaca di atas.
            if (window.history && window.history.replaceState) {
                window.history.replaceState(null, '', window.location.pathname + '#/sso');
            }

            if (!tiket) {
                this.pesan = 'Tiket SSO tidak ditemukan. Buka ulang aplikasi dari SIMASKET.';
                return;
            }

            this.$http.post(this.$apiconfig + 'sso/masuk', { ticket: tiket })
                .then(response => {
                    const hasil = response.data || {};
                    if (hasil.status === 'success' && hasil.user && hasil.user.key) {
                        localStorage.removeItem('email');
                        localStorage.setItem('auth_token', hasil.user.key);
                        axios.defaults.headers.common['Authorization'] = hasil.user.key;
                        this.$router.push('/admin/dashboard');
                    } else {
                        this.pesan = hasil.message || 'Login SSO gagal.';
                    }
                })
                .catch(error => {
                    const data = error.response && error.response.data;
                    this.pesan = (data && data.message) || 'Tidak dapat menghubungi server e-Persediaan.';
                });
        }
    }
</script>

<style scoped>
    .sso-wrap { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #f4f6f9; }
    .sso-kotak { background: #fff; border-radius: 14px; box-shadow: 0 6px 24px rgba(0,0,0,.08); padding: 28px 32px; max-width: 440px; text-align: center; }
</style>
